var map = {
	"./black/chakanjietu.png": "IWbc",
	"./blue/chakanjietu.png": "x0UL",
	"./white/chakanjietu.png": "/HC6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42Ve";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/chakanjietu\.png$
// module id = 42Ve
// module chunks = 24